// Libraries that can't read CSS variables (the map canvas) resolve tokens at
// runtime, so colors still come from the design system (README §11).
export function token(name: string, fallbackVar = "--pm-primary"): string {
  const s = getComputedStyle(document.documentElement);
  return (s.getPropertyValue(name) || s.getPropertyValue(fallbackVar)).trim();
}
